import React from 'react';
import BuildingsCheckListComponent from '../../components/Filters/buildingsCheckList';
import { DOES_NOT_EXIST, NOT_COMPATIBLE_SCHEDULES, SCHEDULE_HASH } from '../../helpers/constants';

class BuildingsCheckList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            value: 'Ninguno',
            checkboxes: [],
            checkAll: false,
            checkCampus: {},
            message: "",
            selectedCalendarHash: null,
        }
        this.setOpen = this.setOpen.bind(this);
        this.setValue = this.setValue.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleClickListItem = this.handleClickListItem.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleOk = this.handleOk.bind(this);
        this.handleChangeAll = this.handleChangeAll.bind(this);
        this.handleChangeCampus = this.handleChangeCampus.bind(this);
    }

    componentDidMount() {
        this.setInitialState();
    };

    componentDidUpdate(prevProps) {
        if ((prevProps.data !== this.props.data) || (prevProps.filters !== this.props.filters)) {
            this.setInitialState();
        }
    }

    notifyParentFilter(){
        const { id, handleChangeSpaceSelect } = this.props;
        const { checkboxes } = this.state;
        if(handleChangeSpaceSelect !== undefined){
            var building = null;
            for (var i = 0; i < checkboxes.length; i++) {
                if(checkboxes[i].checked == true) {
                    building = {
                        id: checkboxes[i].id,
                        name: checkboxes[i].name
                    };
                    break; //we only need one building as they all share the same schedule
                }
            }
            var data = null;
            if(building !== null){   
                data = {
                    building: building,
                    filterId: id
                }
            }
            handleChangeSpaceSelect(data);
        }
    }

    resetFilterMessage(){
        const { id, name, updateFiltersMessage } = this.props;
        const message = {
            id: id,
            name: name,
            parameters: ''
        }
        updateFiltersMessage(message);
    }

    /**
     * Asigna valor de checkboxes.
    */
    setInitialState() {
        const { data } = this.props;
        /*
        const checkCampus = {
            "valparaíso": false,
            "viña del mar": false,
            "san felipe": false,
            "santiago": false
        };
        */
        var checkCampus = {};
        const checkboxes = [];
        for (var i = 0; i < data.length; i++) {
            var campus = data[i].name.replace(/\s*,\s*/g, ",").split(',')[1];
            var checkboxItem = {}
            checkboxItem = {
                campus: campus,
                name: data[i].name,
                id: data[i].id,
                checked: false,
                calendarHash: "-1",
                disabled: false,
                serverDisabled: false,
                errroMessage: ""
            }
            //parse extra data
            if(data[i].subExtraDataList !== undefined && data[i].subExtraDataList.length > 0){ //check if subExtraDataList exists
                for (var item of data[i].subExtraDataList) {
                    switch (parseInt(item.id)) {
                        case SCHEDULE_HASH:
                            checkboxItem.calendarHash = item.name;
                        break;
                        case DOES_NOT_EXIST:
                            checkboxItem.serverDisabled = true;
                            checkboxItem.errroMessage = item.name;
                        break;
                        case NOT_COMPATIBLE_SCHEDULES:
                            checkboxItem.serverDisabled = true;
                            checkboxItem.errroMessage = item.name;
                        break;
                    }
                }
            }
            
            checkboxes.push(checkboxItem);
            checkCampus[campus] = false;
        }
        this.resetFilterMessage();

        this.setState({ 
            checkAll: false,
            checkCampus: checkCampus,
            checkboxes: checkboxes, 
            value: "Ninguno" 
        });
    }

    /**
     * Abre y cierra modal de selección de edificios.
     * @param {Boolean} value - Valor a asignar al estado de apertura.
    */
    setOpen(value) {
        this.setState({ open: value });
    };

    blockIncompatibleBuildings(calendarHash, checkboxes){
        for(var checkbox of checkboxes){
            if(calendarHash === null) { //reset disabled
                if(checkbox.disabled === true){
                    checkbox.disabled = false; 
                    checkbox.errroMessage = '';
                }
            } else {
                if(checkbox.calendarHash !== calendarHash) {
                    checkbox.disabled = true; 
                    checkbox.errroMessage = 'Los horarios de este edificio no son compatibles con los otros edificios seleccionados.';
                }
            }
        }
    }

    /**
     * Asigna valor booleano a campos checkeados.
     * @param {Event} e - Evento que se desencadena al hacer clic sobre un checkbox.
    */
    handleChange(e) {
        const { checkboxes, selectedCalendarHash } = this.state;
        var atLeastOneBuildingSelected = false;
        var newCalendarHash = selectedCalendarHash;
        for (var i = 0; i < checkboxes.length; i++) {
            if (checkboxes[i].id === e.target.id) {
                checkboxes[i].checked = e.target.checked;
                if(newCalendarHash === null){
                    newCalendarHash = checkboxes[i].calendarHash;
                    this.blockIncompatibleBuildings(newCalendarHash, checkboxes);
                }
            }
            if(checkboxes[i].checked == true) {
                atLeastOneBuildingSelected = true;
            }
        }
        if(atLeastOneBuildingSelected == false){
            newCalendarHash = null;
            this.blockIncompatibleBuildings(newCalendarHash, checkboxes);
        }
        this.setState({ 
            checkboxes: checkboxes,
            checkAll: false,
            selectedCalendarHash: newCalendarHash
        });
    };

    /**
     * Asigna el mismo valor booleano a todos los checkbox.
     * @param {Event} e - Evento que se desencadena al hacer clic sobre el checkbox "Todos".
    */
    handleChangeAll(e) {
        const { checkboxes, checkCampus, selectedCalendarHash } = this.state;
        var newCalendarHash = selectedCalendarHash;
        var atLeastOneBuildingSelected = false;
        for (var i = 0; i < checkboxes.length; i++) {
            if ((newCalendarHash === null) && (!checkboxes[i].disabled && !checkboxes[i].serverDisabled)){
                newCalendarHash = checkboxes[i].calendarHash;
                this.blockIncompatibleBuildings(newCalendarHash, checkboxes);
                checkboxes[i].checked = e.target.checked;
            } else {
                if((newCalendarHash === checkboxes[i].calendarHash) && (!checkboxes[i].disabled && !checkboxes[i].serverDisabled)){
                    checkboxes[i].checked = e.target.checked;
                }
            }
            if(checkboxes[i].checked == true) {
                atLeastOneBuildingSelected = true;
            }
        }
        if(atLeastOneBuildingSelected == false){
            newCalendarHash = null;
            this.blockIncompatibleBuildings(newCalendarHash, checkboxes);
        }
        for (var campus in checkCampus) {
            checkCampus[campus] = e.target.checked;
        }
        this.setState({ 
            checkAll: e.target.checked,
            checkCampus: checkCampus,
            checkboxes: checkboxes,
            selectedCalendarHash: newCalendarHash
        });
    }

    /**
     * Asigna valor a checkbox por campus.
     * @param {Event} e - Evento que se desencadena al hacer clic sobre un checkbox de campus.
    */
    handleChangeCampus(e) {
        const { checkboxes, selectedCalendarHash } = this.state;
        var newCalendarHash = selectedCalendarHash;
        var atLeastOneBuildingSelected = false;
        for (var i = 0; i < checkboxes.length; i++) {
            var campus = checkboxes[i].campus;
            if (campus.toUpperCase() == e.target.value.toUpperCase()) {
                if ((newCalendarHash === null) && (!checkboxes[i].disabled && !checkboxes[i].serverDisabled)){
                    newCalendarHash = checkboxes[i].calendarHash;
                    this.blockIncompatibleBuildings(newCalendarHash, checkboxes);
                    checkboxes[i].checked = e.target.checked;
                } else {
                    if((newCalendarHash === checkboxes[i].calendarHash) && (!checkboxes[i].disabled && !checkboxes[i].serverDisabled)){
                        checkboxes[i].checked = e.target.checked;
                    }
                }
            }
            if(checkboxes[i].checked == true) {
                atLeastOneBuildingSelected = true;
            }
        }
        if(atLeastOneBuildingSelected == false){
            newCalendarHash = null;
            this.blockIncompatibleBuildings(newCalendarHash, checkboxes);
        }
        this.setState({ 
            checkCampus: { ...this.state.checkCampus, [e.target.value]: e.target.checked },
            checkboxes: checkboxes,
            checkAll: false,
            selectedCalendarHash: newCalendarHash
        });
    }

    /**
     * Asigna texto secundario con edificios seleccionados.
     * @param {String} e - Texto con edificios seleccionados.
    */
    setValue(value) {
        this.setState({ value: value });
    };

    /**
     * Abre modal con edificios al hacer clic sobre item de edificios en Filtros.
    */
    handleClickListItem() {
        this.setOpen(true);
    };

    /**
     * Cierra modal de selección de edificios y asigna texto secundario con edificios seleccionados.
     * @param {String} newValue - Texto con edificios seleccionados.
    */
    handleClose(newValue) {
        this.setOpen(false);
        if (newValue) {
            this.setValue(newValue);
        }
    };

    /**
     * Crea y asigna mensaje de datos seleccionados en el filtro al hacer clic en "Ok" en el modal.
    */
    handleOk() {
        //crear mensaje filtro y agregar a array de mensaje de filtros (en chartview)
        const { id, name, updateFiltersMessage  } = this.props;
        const { checkboxes, selectedCalendarHash } = this.state;
        var parameters = '';
        var parametersArray = []
        var checkedValues = [];
        checkboxes.map(parameter => {
            if ((parameter.checked) && (parameter.calendarHash === selectedCalendarHash)) {
                parametersArray.push(
                    '<parameter>',
                    '<id>',
                    parameter.id,
                    '</id>',
                    '<name>',
                    parameter.name,
                    '</name>',
                    '</parameter>'
                );

                checkedValues.push(parameter.name)
            }
        });
        parameters = parametersArray.join('');
        const message = {
            id: id,
            name: name,
            parameters: parameters
        }

        updateFiltersMessage(message);
        this.setState({ message: message });
        const values = checkedValues.join(", ");
        var secondaryText = checkedValues.length === 0 ? 'Ninguno' : values;
        this.handleClose(secondaryText);
        this.notifyParentFilter();
    };

    render() {
        const { open, value, checkboxes, checkAll, checkCampus } = this.state;
        const { data, required, height } = this.props;
        return (
            <BuildingsCheckListComponent
                height={height}
                open={open}
                value={value}
                data={data}
                required={required}
                checkAll={checkAll}
                checkCampus={checkCampus}
                checkboxes={checkboxes}
                handleClickListItem={this.handleClickListItem}
                handleChange={this.handleChange}
                handleOk={this.handleOk}
                handleChangeAll={this.handleChangeAll}
                handleChangeCampus={this.handleChangeCampus}
            />
        )
    }
}

export default BuildingsCheckList;